const styles = (theme) => ({
    container: {
        width: 'fit-content',
        marginTop: '-39px',
    },
    accountContainer: {
        paddingRight: '40px',
        paddingLeft: '32px',
        flex: 1,
    },
    leftSectionContainer: {
        paddingTop: '30px',
    },
    planContainer: {
        flex: 1,
        height: '100%',
        padding: '0 40px 120px 40px',
        marginTop: '20px',
        background: theme.custom.bgLightAccentColor,
        [theme.breakpoints.up('sm')]: {
            marginTop: '0px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0 40px 40px 40px',
        },
    },
    link: {
        color: theme.custom.linkColor,
        textDecoration: 'underline',
        fontSize: '18px',
        fontWeight: 700,
        paddingTop: '20px',
    },
    billingHistoryContainer: {
        margin: '0px 32px',
        borderTop: `1px solid ${theme.custom.bgLightAccentColor}`,
    },
});

export default styles;
